export default {"src":"/_next/static/media/topbarhome.ebb02109.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};